import { ReactNode } from 'react'
import cx from 'classnames'

import AccordionItem from './AccordionItem'

type Props = {
  children: ReactNode
  className?: string
}

const Accordion = ({ children, className }: Props) => {
  return <div className={cx('w-full ', className)}>{children}</div>
}

Accordion.Item = AccordionItem

export default Accordion
